import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		padding: "8px 10px 12px",
		gap: 8,
		borderRadius: 14,
		background: theme.mode === "light" ? "rgba(255,255,255,.64)" : "rgba(15,24,45,.6)",
		border: `1px solid ${theme.palette.divider}`,
		backdropFilter: "blur(10px)",
		WebkitBackdropFilter: "blur(10px)",
		marginBottom: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			padding: "8px",
			borderRadius: 12,
			gap: 6,
			backdropFilter: "none",
			WebkitBackdropFilter: "none",
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
